import {
    Box,
    Chip,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import stringUtils from "../../utils/stringUtils";
import { Link } from "react-router-dom";

const TableRelatorios = (props) => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState(0);

    useEffect(async () => {
        setRows(props.rows);
    }, [props.rows]);
    useEffect(async () => {
        setTotal(props.total);
    }, [props.total]);
    useEffect(async () => {
        setPagina(props.pagina);
    }, [props.pagina]);

    const padding = props.padding ? props.padding : 12;

    const emptyRows = 10 - Math.min(10, rows.length);

    return (
        <Paper>
            <TableContainer>
                <Table aria-label="sticky table" sx={{ minHeight: "38rem" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Data</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Usuário</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Tipo</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Valor</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Documento</b>
                                </Box>
                            </TableCell>
                            {props.camposListagem.map((item) => (
                                <TableCell align="center" key={item.chave}>
                                    <Box color="primaryDark.main">
                                        <b>{item.label}</b>
                                    </Box>
                                </TableCell>
                            ))}
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Status</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Ações</b>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box fontSize={13}>
                                            {stringUtils.formatDateComplete(
                                                row.data_relatorio
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box fontSize={13}>
                                            {row.usuario_nome}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box fontSize={13}>
                                            {row.nome_consulta}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box
                                            fontSize={13}
                                            color={
                                                row.status != 3
                                                    ? "green"
                                                    : "red"
                                            }>
                                            {stringUtils.formatBRL(row.valor)}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box fontSize={13}>
                                            {stringUtils.formatDocumento(
                                                row.documento
                                            )}
                                        </Box>
                                    </TableCell>
                                    {props.camposListagem.map((item) => (
                                        <TableCell
                                            key={item.chave}
                                            align="center"
                                            style={{ padding: padding }}>
                                            <Box fontSize={13}>
                                                {row.dados_extras[item.chave]
                                                    ? stringUtils.cutString(
                                                          row.dados_extras[
                                                              item.chave
                                                          ]
                                                      )
                                                    : "-"}
                                            </Box>
                                        </TableCell>
                                    ))}
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        <Box fontSize={13}>
                                            {row.status == 2 ? (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#6CA76B",
                                                        color: "#FFF",
                                                    }}
                                                    label="Processada"
                                                />
                                            ) : row.status == 3 ? (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#F44336",
                                                        color: "#FFF",
                                                    }}
                                                    label="Error"
                                                />
                                            ) : (
                                                <Chip
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            "#BDBDBD",
                                                        color: "#FFF",
                                                    }}
                                                    label="Em Processamento"
                                                />
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}>
                                        {row.status == 2 && (
                                            <Tooltip title="Visualizar">
                                                <IconButton
                                                    component={Link}
                                                    to={`/relatorios/${row.id}`}
                                                    aria-label="visualizar"
                                                    size="small"
                                                    height={11}
                                                    width={11}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={7} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={parseInt(total)}
                rowsPerPage={10}
                page={parseInt(pagina)}
                onChangePage={props.handleChangePage}
            />
        </Paper>
    );
};

export default TableRelatorios;
